
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
@Component({
  name: "treeView",
  components: {},
})
export default class treeView extends BaseVue {
  @Prop({ default: () => [] }) data!: any; //树组件数据
  @Prop({ default: () => null }) render!: any; //自定义节点内容渲染函数
  @Prop({ default: () => false }) showCheckbox!: Boolean; //是否复选框模式
  @Prop({ default: () => false }) multiple!: Boolean; //是否多选
  @Prop({ default: () => true }) checkStrictly!: Boolean; //在显示复选框的情况下，是否严格的遵循父子不互相关联的做法
  @Prop({ default: () => "Id" }) nodeKey!: any; //节点数据唯一标识 key
  @Prop({ default: () => true }) selectNode!: Boolean; //点击节点时是否有选中效果

  treeData: any = [];
  @Watch("data")
  dataChange() {
    this.treeData = this.data;
  }
  mounted() {
    this.treeData = this.data;
  }
  renderContent1(h, { root, node, data }) {
    return h(
      "span",
      {
        attrs: {
          title: data.title,
        },
        style: {
          display: "inline-block",
          width: "100%",
          // height: '30px',
          // 'line-height': '30px',
          overflow: "hidden",
          "text-overflow": "ellipsis",
        },
      },
      [
        h("span", [
          h("Icon", {
            props: {
              type:
                data.children && data.children.length > 0
                  ? "ios-folder-outline"
                  : "ios-paper-outline",
            },
            style: {
              marginRight: "8px",
            },
          }),
          h("span", data.title),
        ]),
      ]
    );
  }
  /**
   * @description: 点击树节点时触发
   * @param {*} nodes 当前已选中的节点数组
   * @param {*} item  当前项
   * @return {*}
   * @author: pangting
   */
  onSelectChange(nodes, item) {
    this.$emit("on-select-change", item, nodes);
  }
  /**
   * @description: 点击复选框时触发
   * @param {*} nodes 当前已勾选节点的数组
   * @param {*} item  当前项
   * @return {*}
   * @author: pangting
   */
  onCheckChange(nodes, item) {
    this.$emit("on-check-change", item, nodes);
  }
  /**
   * @description: 展开和收起子列表时触发
   * @param {*} item  当前节点的数据
   * @return {*}
   * @author: pangting
   */
  onToggleExpand(item) {
    this.$emit("on-toggle-expand", item);
  }
  // 节点右键点击事件
  onContextmenu(item) {
    this.$emit("on-contextmenu", item);
  }
  // 根据Id选中某节点
  setSelectedTreeById(id, treeData = this.treeData) {
    treeData.forEach((item, index) => {
      if (item[this.nodeKey] == id) {
        this.$set(item, "selected", true);
      } else {
        this.$set(item, "selected", false);
      }
      if (item.children && item.children.length > 0) {
        this.setSelectedTreeById(id, item.children);
      }
    });
  }
  loadData(item, callback) {
    this.$emit("asyncNodesLoad", item, callback);
  }
  setTreeNodeParam(id, changeKey, changeKeyValue, treeData) {
    if (typeof id == "number") {
      id = id.toString();
    }
    treeData = treeData ? treeData : this.treeData;
    treeData.forEach((item, index) => {
      if (id.indexOf(item[this.nodeKey]) >= 0) {
        this.$set(item, changeKey, changeKeyValue);
      }
      if (item.children && item.children.length > 0) {
        this.setTreeNodeParam(id, changeKey, changeKeyValue, item.children);
      }
    });
  }

  setTreeNodeExpandById(id, treeData = this.treeData) {
    treeData.forEach((item, index) => {
      if (item[this.nodeKey] == id) {
        this.$set(item, "expand", true);
      } else {
        this.$set(item, "expand", false);
        this.$set(item, "children", []);
      }
      if (item.children && item.children.length > 0) {
        this.setSelectedTreeById(id, item.children);
      }
    });
  }

  // 获取被勾选的节点
  getCheckedNodes() {
    return this.ref("nv-tree").getCheckedNodes();
  }
  // 获取被选中的节点
  getSelectedNodes() {
    return this.ref("nv-tree").getSelectedNodes();
  }
  // 获取选中及半选节点
  getCheckedAndIndeterminateNodes() {
    return this.ref("nv-tree").getCheckedAndIndeterminateNodes();
  }
}
